import React from "react";

import { CARDS_PER_ROW } from "@/components/Search/constants";
import { MobileShowAllResultsButtonProps } from "../types";
import { getTypeBackgroundColor } from "@/components/NewProductCard/utils/mapTypeToColor";

function MobileShowAllResultsButton({
  handleTabClick,
  results,
  title,
  cardsPerRow = CARDS_PER_ROW,
  hitType,
}: MobileShowAllResultsButtonProps) {
  return (
    <div className="flex justify-center lg:hidden">
      <button
        onClick={handleTabClick}
        className={`flex items-center rounded-xl border shadow underline text-primary text-xl h-[370px] w-[270px] px-8 text-center whitespace-normal ${getTypeBackgroundColor(hitType ?? "")}`}
      >
        <span>{`Show ${(results?.nbHits || 0) > cardsPerRow ? "all" : ""} ${results?.nbHits || 0} ${title.toLocaleLowerCase()}`}</span>
      </button>
    </div>
  );
}

export default MobileShowAllResultsButton;
